module.exports = __webpack_public_path__ + "img/exScan.8afb4d5c.jpg";